import { withLoader, withAsyncEnterLoader } from 'util/routeHelper';
import { verifyEmail } from 'actions/auth';

export default store => ({
	path: 'verify',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'Verify',
				),
			store,
			'VERIFY',
		),
	},

	onEnter: withAsyncEnterLoader(
		async ({ location: { query: { token } } }, __, updateRatio) => {
			updateRatio(0.8);
			await store.dispatch(verifyEmail(token));
			updateRatio(1);
		},
		store,
		'ENTER_VERIFY',
	),
});



// WEBPACK FOOTER //
// ./src/routes/Verify/index.js